<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex combo_box">
      <!-- {{ farm }} -->
      <v-select dense outlined
        id="farm"
        ref="farm"
        class="select_farm"
        prepend-inner-icon="mdi-home-circle"
        v-model="farm"
        :items="farmItems"
        :menu-props="{ top: false, offsetY: true }"
        no-data-text="자료(권한)이 없습니다."
        item-text="name"
        return-object
        @change="changeFarm()"
        @focus="comboFarms()"
        clearable
      >
      </v-select>
      <v-select dense outlined
          id="building" 
          ref="building" 
          class="select_building"
          v-model="building"
          :items="buildingItems"
          :menu-props="{ top: false, offsetY: true }"
          no-data-text="자료(권한)이 없습니다."
          item-text="name"
          return-object
          @change="changeBuilding()"
          @focus="comboBuildings()"
          clearable
        >
      </v-select>
      <button
        class="refresh_btn mt-2" 
        @click="refresh()">
        <v-icon color="white">
          mdi-refresh
        </v-icon>
      </button> 
    </div>
<!-- 
    {{ building }}
    <pre>company: {{ building.company_cd }}</pre> -->

    <div :loading="loading" nowrap outlined class="table-container" > 
      <div id="seasonTable" >

        <div class="season_header" style="display:flex">
          <div style="display: flex;"> 
            <div class="table_title"> 
              <v-dialog
                  v-model="dialogWeight"
                  max-width="400" 
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div  
                      class="weight_btn elevation-3 mt-5 ml-1" v-show="edit_mode"
                      v-bind="attrs"
                      v-on="on"
                      @click="newWeight">
                      <v-icon
                        color=white
                        size="10"
                      >
                        mdi-plus
                      </v-icon>
                      <span class="mr-1"> 체중 </span>
                    </div>
                  </template>
                <WeightSet
                  :setData="setData" 
                  @close="dialogWeight = false"
                  @refresh="refresh"
                  @checkDuplicate="weightDuplicate"
                />
              </v-dialog>
              <span v-show="edit_mode" class="ml-1 mr-1"> \ </span>
              <v-dialog
                v-model="dialogSeason"
                max-width="350"
              >
                <template v-slot:activator="{ on, attrs }">            
                  <div outlined class="weight_btn elevation-3 mb-2" 
                    v-show="edit_mode && header_weight.length"
                    v-bind="attrs"
                    v-on="on" 
                    @click="newSeason">
                    <v-icon
                    color=white
                    size="10"
                    >
                      mdi-plus
                    </v-icon>
                    <span class="mr-1">계절</span>
                  </div>
                </template>
                  <SeasonSet 
                    :season_setData="season_setData"
                    @close="dialogSeason = false"
                    @refresh="refresh"
                    @checkDuplicate="seasonDuplicate"
                  />
              </v-dialog>

              <div v-show="!edit_mode" class="mt-1">
                <span> 체중 \ 계절</span>
              </div>
            </div>
            <div class="season_section" tabindex="-1" :class="{ cursorpointer: edit_mode, set_click:edit_mode }" v-for="(header_season,hs) in header_season" :key="hs" @click="updateSeasonRange(header_season)"> 
              <div style="font-size:16px;"> {{header_season.season_name}} </div>
              <div class="header_date">{{ dateMD(header_season.season_from) }}-{{dateMD(header_season.season_to)}}</div>
            </div>
        </div>
        </div>
      
      <div>
        <div style="display:flex">
          <div class="weight_header">
            <div>
              <div class="weight_section" tabindex="-1" :class="{ cursorpointer: edit_mode, set_click:edit_mode }"
                  v-for="(header_weight,hw) in header_weight" :key="hw" 
                  @click="updateWeightRange(header_weight)"> 
                  
                <div style="font-size:16px"> {{header_weight.weight_name}} </div>
                <div class="weight_des"> {{header_weight.weight_min}} - {{header_weight.weight_max}} kg </div>
                <div class="weight_des" v-if="header_weight.age_min"> {{header_weight.age_min}} - {{header_weight.age_max}}주 </div>
              </div>

            </div>
        </div>

        <div style="display:flex">
          <div class="controlContents">
              <div v-for="(weight,w) in weight_list" :key="w">
                <v-layout>
                  <div v-for="(season,s) in weight.season_list" :key="s">
                    <div class="setting" tabindex="-1" v-if="season.season_id" :class="{cursorpointer:edit_mode, set_click:edit_mode}" @click="updateControlRange(weight, season)"> 
                    <div class="fc_info" v-if="season.fan" >
                      <div class="fc_content">
                        <div class="fc_number">1</div>
                        <div class="flex">
                          <div class="fc_vent"> {{season.fan.min_vent1}} - {{season.fan.max_vent1}} </div>
                          <span> | </span>
                          <div class="ml-1 mr-1">{{season.fan.set_temp1}}  </div>
                          <span> | </span>
                          <div class="ml-1 mr-1">{{ season.fan.dev_temp1 }} </div>
                        </div>
                      </div>
                      <div class="fc_content">
                        <div class="fc_number">2</div>
                        <div class="flex">
                          <div class="fc_vent"> {{season.fan.min_vent2}} - {{season.fan.max_vent2}} </div>
                          <span> | </span>
                          <div class="ml-1 mr-1"> {{season.fan.set_temp2}}  </div>
                          <span> | </span>
                          <div class="ml-1 mr-1"> {{ season.fan.dev_temp2 }} </div>
                        </div>
                      </div>
                      <div class="fc_content">
                        <div class="fc_number">3</div>
                        <div class="flex">
                          <div class="fc_vent"> {{season.fan.min_vent3}} - {{season.fan.max_vent3}} </div>
                          <span> | </span>
                          <div class="ml-1 mr-1">{{season.fan.set_temp3}}  </div>
                          <span> | </span>
                          <div class="ml-1 mr-1">{{ season.fan.dev_temp3 }} </div>
                        </div>
                      </div>
                    </div>
                  
                    <div class="heater_info" v-if="season.heater">
                      <div>
                        {{ season.heater.on_off1 ?  `${season.heater.min_vent1} - ${season.heater.max_vent1} / ${season.heater.set_temp1}` : "OFF" }} </div> 
                    </div>
                  </div>
                  </div>     
                  </v-layout>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--컨트롤러 세팅 pop-up-->
      <v-dialog
        v-model="dialogSet"
        max-width="500"
      >
        <ControllerSet class=""
        :control_setData="control_setData"
        @close="dialogSet = false"
        @refresh="refresh"/>
      </v-dialog>


      <v-row class="justify-center mb-1">
        <v-btn v-show="editBtnShow" v-if="$getters.userInfo.grade < 'UT06'" outlined rounded class="modify_btn elevation-3" 
          @click="edit_mode = !edit_mode; $store.commit('resMessage',''); presetLoadShow=edit_mode; presetSaveShow=!edit_mode;"> 
          {{edit_mode ? "나가기" : "수정하기"}}
        </v-btn>

        <v-btn v-show="presetCanceShow" @click="refresh();" outlined rounded class="modify_btn elevation-3 cancel lightgreen ml-2">
              되돌리기
        </v-btn>

 
        <template>
          <div class="text-center">
            <v-btn v-show="presetLoadShow" @click="loadDialog = true; presetCompany={}; preset='';" outlined rounded class="modify_btn elevation-3 darkblue ml-2">
              프리셋 불러오기
            </v-btn>

            <v-dialog v-model="loadDialog" width="350">
              <v-card max-width="350" class="pa-5" style="border-radius:15px;">
                <span class="dialog_title">프리셋 불러오기</span>

                <div class="flex mb-2 mt-2">
                  <div class="preset_title">경영체</div>
                  <v-select dense outlined rounded class="select_farm" 
                    id="presetCompany" 
                    ref="presetCompany" 
                    v-model="presetCompany"
                    :items="presetCompanyItems"
                    :menu-props="{ top: false, offsetY: true }"
                    no-data-text="자료(권한)이 없습니다."
                    item-text="name"
                    return-object
                    @focus="comboPresetCompanies()"
                    clearable
                    />
                </div>

                <div class="flex mb-2 mt-2">
                  <div class="preset_title">프리셋</div>
                  <v-select dense outlined rounded class="select_farm ma-1"
                    id="preset" 
                    ref="preset" 
                    v-model="preset"
                    :items="presetItems"
                    :menu-props="{ top: false, offsetY: true }"
                    no-data-text="자료(권한)이 없습니다."
                    return-object
                    @focus="comboPresets()"
                    clearable
                    />
                </div>

                <div class="flex vertical-center mt-3">
                  <button @click="loadDialog = false" class="apply_btn brandcolor">닫기</button>
                  <button @click="presetLoad()" class="apply_btn brandback">불러오기</button>
                </div>
              </v-card>
            </v-dialog>
          </div>
        </template>

        <template>
          <div class="text-center">
            <v-btn v-show="presetSaveShow" outlined rounded class="modify_btn elevation-3 sblue ml-2 mr-2" 
              @click="saveDialog = true; presetCompany={}; presetNm='';"> 
              프리셋으로 저장
            </v-btn>

            <v-dialog v-model="saveDialog" width="350">
              <v-card max-width="350" class="pa-5" style="border-radius:15px;">
                <span class="dialog_title">프리셋으로 저장</span>

                
                <div class="flex mb-2 mt-2">
                  <div class="preset_title">경영체</div>
                  
                  <v-select class="select_farm" dense outlined rounded 
                    id="presetCompany" 
                    ref="presetCompany" 
                    v-model="presetCompany"
                    :items="presetCompanyItems"
                    :menu-props="{ top: false, offsetY: true }"
                    no-data-text="자료(권한)이 없습니다."
                    item-text="name"
                    return-object
                    @focus="comboPresetCompanies()"
                    clearable
                    />
                </div>

                 <div class="flex mb-2 mt-2">
                  <div class="preset_title">프리셋명</div>
                  <v-text-field dense outlined rounded clearable class="select_preset"
                    id="presetNm" 
                    ref="presetNm" 
                    v-model="presetNm"
                  ></v-text-field>
                 </div>

                <div class="flex vertical-center mt-3">
                  <button @click="saveDialog = false" class="apply_btn brandcolor">취소</button>
                  <button @click="presetSave()" class="apply_btn brandback">확인</button>
                </div>
              </v-card>
            </v-dialog>
          </div>
        </template>

        <template>
          <div class="text-center">
            <v-btn v-show="presetConfirmShow" outlined rounded class="modify_btn elevation-3 ml-2 sky" 
              @click="presetConfirm()"> 
              적용하기
            </v-btn>
          </div>
        </template>
      </v-row>

    </div>

  </div>
</template>

<script>
import Apis from '@/api/apis';
import VueCookies from "vue-cookies";
import dateUtil from "@/utils/custom/dateProperty.js"; 

import WeightSet from './child/WeightSet.vue';
import SeasonSet from './child/SeasonSet.vue';
import ControllerSet from './child/ControllerSet.vue';
const year = dateUtil.format(new Date(), "yyyy-");

export default {
  name: "ControlTable",

  components: {
    WeightSet,
    SeasonSet,
    ControllerSet
  },

  async created() {
    Apis.pageCount({
        page_name: this.$route.name,
        url: this.$route.path,
        division: "cloud",
    }, () => {
    }).catch((err) => {
        console.log("pageCount 호출 오류", err);
    });
    // await this.comboCompanies();
    await this.comboFarms();
    await this.comboBuildings();
    
    let cookie_info = VueCookies.get("controltable_info");
    if (!this.isNull(this.$route.params)) {
      //console.log("Params : ", this.$route.params);
      this.company = this.$route.params.company;
      this.farm = this.$route.params.farm;
      if ( this.$route.params.building && this.$route.params.building.code) {
        this.building = this.$route.params.building
      } else { 
          await this.comboBuildings();
          this.building = this.buildingItems[0];
      }
    } else if (cookie_info) {
          this.farm = cookie_info.farm || {};
          this.building = cookie_info.building || {};
          this.company = {code : this.building.company_cd, name : this.building.company_name}|| {};
    } else { // 이전 조회정보가 없을 경우 첫번째 농장/사업장 디폴트로 참조
          this.building = this.buildingItems[0];
          this.farm = { code: this.building.farm_cd, name: this.building.farm_name };
          this.company={code : this.building.company_cd, name : this.building.company_name}
    }
    this.refreshList();
  },

  data() {
    return {
      icon_fangreen: require("@/assets/control/fan_control_green.svg"),
      farm: {},
      farmItems: [],
      building: {},
      buildingItems: [],
      loading: false,
      weight_list: [],
      season_list: [],
      header_season: [],
      header_weight: [],
      edit_mode: false,
      combobox: true,
      data_text: "",

      dialogWeight: false,
      dialogSeason: false,
      dialogSet: false,

      setData: {},
      season_setData: {},
      control_setData: {},
      msgFlag: true,

      loadDialog:false,
      saveDialog:false,

      presetCompany:{},
      presetCompanyItems:[],
      preset:'',
      presetItems:[],
      presetNm:'',

      editBtnShow: true,
      presetLoadShow: false,
      presetSaveShow: true,
      presetConfirmShow: false,
      presetCanceShow: false,
    };
  },
  methods: {
    newSeason(){
      this.$store.commit("resMessage","");
      this.season_setData = {company_cd: this.building.company_cd,
                            farm_cd: this.farm.code,
                            building_cd: this.building.code,
                            building_name: this.building.name,
                            season_name: "",
                            season_from: "",
                            season_to: "",
                            description:"",
                            history:"",
                            season_id:0 };
                      // console.log(this.season_setData)
    },
    updateSeasonRange(item) {
      if (!this.edit_mode) return;
      this.$store.commit("resMessage","");
      this.season_setData = {company_cd: this.building.company_cd,
                            farm_cd: this.farm.code,
                            building_cd: this.building.code,
                            building_name: this.building.name,
                            season_name: item.season_name,
                            season_from: dateUtil.format(new Date(), "yyyy-")+item.season_from,
                            season_to: dateUtil.format(new Date(), "yyyy-")+item.season_to,
                            season_id: item.id,
                            description: item.descripton,
                            history: item.history,
                          };
      this.dialogSeason = true;
    },
    newWeight() {
      this.$store.commit("resMessage","");
      this.setData = {company_cd: this.building.company_cd,
                      farm_cd: this.farm.code,
                      building_cd: this.building.code,
                      building_name: this.building.name,
                      weight_name: "",
                      weight_min: 0,
                      age_min: 0,
                      age_max: 0,
                      weight_max: 0,
                      description: "",
                      weight_id: 0,
                      history: "",
                      };
                      console.log(this.farm)
    },
    updateWeightRange(item) {
      // console.log(item)
      if (!this.edit_mode) return;
      this.$store.commit("resMessage","");
      this.setData = {company_cd: this.building.company_cd,
                      farm_cd: this.farm.code,
                      building_cd: this.building.code,
                      building_name: this.building.name,
                      weight_id: item.id,
                      weight_name: item.weight_name,
                      weight_min: item.weight_min,
                      weight_max: item.weight_max,
                      age_min: item.age_min,
                      age_max: item.age_max,
                      description: item.descripton,
                      history: item.history,
                    };
      this.dialogWeight = true;
    },

    updateControlRange(weight, season){
      // console.log(weight, season);

      if (!this.edit_mode) return;
      this.$store.commit("resMessage","");
      this.control_setData = {company_cd: this.building.company_cd,
                              farm_cd: this.farm.code,
                              building_cd: this.building.code,
                              building_name: this.building.name,

                              season_id: season.season_id,
                              season_name: season.season_name,
                              weight_id: weight.weight_id,
                              weight_name: weight.weight_name,

                              fan: {on_off1 : true,
                              on_off2: true,
                              on_off3: true,
                              set_temp1: season.fan && season.fan.set_temp1 || 0, 
                              dev_temp1: season.fan && season.fan.dev_temp1 || 0, 
                              max_vent1: season.fan && season.fan.max_vent1 || 0, 
                              min_vent1: season.fan && season.fan.min_vent1 || 0 ,
                              set_temp2: season.fan && season.fan.set_temp2 || 0, 
                              dev_temp2: season.fan && season.fan.dev_temp2 || 0, 
                              max_vent2: season.fan && season.fan.max_vent2 || 0, 
                              min_vent2: season.fan && season.fan.min_vent2 || 0,
                              set_temp3: season.fan && season.fan.set_temp3 || 0, 
                              dev_temp3: season.fan && season.fan.dev_temp3 || 0, 
                              max_vent3: season.fan && season.fan.max_vent3 || 0, 
                              min_vent3: season.fan && season.fan.min_vent3 || 0},

                              heater:{ set_temp1: season.heater && season.heater.set_temp1 || 0, 
                              dev_temp1: season.heater && season.heater.dev_temp1|| 0, 
                              max_vent1: season.heater && season.heater.max_vent1 || 0, 
                              min_vent1: season.heater && season.heater.min_vent1 || 0,
                              on_off1: season.heater && season.heater.on_off1 || false,}
                              };
      this.dialogSet = true;
    },

    dateMD(md) {
        let m = md.slice(0, 2);
        let d = md.slice(3);
        m = (m.slice(0, 1) == "0") ? m.slice(1) : m;
        d = (d.slice(0, 1) == "0") ? d.slice(1) : d;
        return m + "/" + d;
    },
    refresh() {
      this.dialogWeight = false;
      this.dialogSeason = false;
      this.dialogSet = false;

      this.presetConfirmShow=false;
      this.presetSaveShow=true;
      this.editBtnShow=true;

      this.presetLoadShow = false,
      this.presetCanceShow = false,


      this.msgFlag = false;
      this.refreshList();
    },

    refreshList() {
      if (this.msgFlag) this.$store.commit("resMessage","");
      if (!this.building || !this.building.code) {
          alert("축사/건물/구역를 선택하세요");
          this.$refs.building.focus();
          return;
      }
      this.loading = true;
      Apis.listControlRangeSettings({
          building_cd: this.building && this.building.code || "",
      }, (res) => {
          this.header_weight = [];
          this.header_season = [];
          this.weight_list = res.data;
          this.weight_list.forEach(item => {
              this.header_weight.push({ id: item.weight_id, weight_name: item.weight_name,
                                        weight_min: item.weight_min, weight_max: item.weight_max,
                                        age_min: item.age_min, age_max: item.age_max,
                                        descripton: item.w_description, history: `${item.w_reguser} / ${item.w_regdate} 등록` });
          });
          if (this.weight_list[0] && this.weight_list[0].season_list[0].season_id) {
           for (let i in this.weight_list[0].season_list) {
              this.header_season.push(
                { id: this.weight_list[0].season_list[i].season_id, season_name: this.weight_list[0].season_list[i].season_name, 
                  season_from: this.weight_list[0].season_list[i].season_from, season_to: this.makeSeasonTo(i),
                  descripton: this.weight_list[0].season_list[i].s_description,
                  history: `${this.weight_list[0].season_list[i].s_reguser} / ${this.weight_list[0].season_list[i].s_regdate} 등록`  }
              );
            }
          }
          if (this.msgFlag) this.$store.commit("resMessage",res.message);
          this.loading = false;
          this.msgFlag = true;
          let cookie_info = { company: this.farm.company_cd, farm: this.farm, building: this.building };
          VueCookies.set("controltable_info", cookie_info, "30d");
      }).catch((err) => {
          console.log("listControlRangeSettings 호출 오류", err);
          this.loading = false;
      });
    },
    weightDuplicate(id,name,w_min,a_min,callback) {
      let res = "";
      for (let i in this.header_weight) {
        if (this.header_weight[i].id !== id) {
          if (this.header_weight[i].weight_name == name) {res = "구간명이 중복됩니다"; break;}
          if (this.header_weight[i].weight_min == w_min) {res = "체중하한이 중복됩니다"; break;}
          if (this.header_weight[i].age_min == a_min) {res = "주령하한이 중복됩니다"; break;}
        }
      }
      return callback(res);
    },
    seasonDuplicate(id,s_from,callback) {
      let res = "";
      for (let i in this.header_season) {
        if (this.header_season[i].id !== id) {
          if (this.header_season[i].season_from == s_from) {res = "계절 시작일이 중복됩니다"; break;}
        }
      }
      return callback(res);
    },
    async comboFarms() {
      await Apis.comboFarms({
        company_cd: "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.farmItems = [];
            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              code: res.data[i].farm_cd,
              name: res.data[i].farm_name,
              });
            }  
            // console.log("farmItems:", this.farmItems); 
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFarms API 호출 오류",err)
        }
      ) 
    },
    changeFarm() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      if (this.farm && this.farm.company_cd) {
        this.company = {code: this.farm.company_cd, name: this.farm.company_name};
      }
      this.building = {}; this.buildingItems = [];
    },
    async comboBuildings() {
      await Apis.comboBuildings({
        company_cd: this.farm.company_cd || "",
        farm_cd: this.farm && this.farm.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.buildingItems = [];
            for (let i in res.data) {
            this.buildingItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              farm_cd: res.data[i].farm_cd, 
              farm_name: res.data[i].farm_name, 
              code: res.data[i].building_cd,
              name: res.data[i].building_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboBuildings API 호출 오류",err)
        }
      ) 
    },
    changeBuilding() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      if (this.building) {
        this.company = {code: this.building.company_cd, name: this.building.company_name};
        this.farm = {code: this.building.farm_cd, name: this.building.farm_name};
        this.refreshList();
      }
    },
    makeSeasonTo(index) {      // 다음 시즌 시작일의 하루 전날로 까지날짜 세팅
      let n_from = year + this.weight_list[0].season_list[0].season_from;
      if (index < this.weight_list[0].season_list.length - 1 ) {
        n_from =  year + this.weight_list[0].season_list[Number(index) + 1].season_from;
      } 
      return dateUtil.format(dateUtil.addDays(new Date(n_from), -1),"MM-dd"); 
    },

    async comboPresetCompanies(){
      await Apis.comboCompanies({
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.presetCompanyItems = [{code: "ALL", name: "전 경영체 공용"}];
            for (let i in res.data) {
            this.presetCompanyItems.push({
              code: res.data[i].company_cd,
              name: res.data[i].company_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboPresetCompanies API 호출 오류",err)
        }
      ) 
    },
    async comboPresets(){
      await Apis.comboFanControlPresets({
        company_cd: this.presetCompany && this.presetCompany.code || "",
        },(res) => {  
          if (res.result) {
            this.presetItems = res.data
            }  
          else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFanControlPresets API 호출 오류",err)
        }
      ) 
    },
    presetLoad(){
      if (!this.presetCompany || !this.presetCompany.code) {
          alert("프리셋 공유 경영체를 선택하세요");
          this.$refs.presetCompany.focus();
          return;
      }
      if (this.preset == "") {
          alert("불러올 프리셋을 선택하세요");
          this.$refs.preset.focus();
          return;
      }
      this.loading = true;
      Apis.loadFanControlPreset({
          company_cd: this.presetCompany.code,
          preset_name: this.preset,
      }, (res) => {
          if (res.result) {
            this.weight_list = res.data;
            this.header_weight = [];
            this.header_season = [];
            this.weight_list.forEach(item => {
              this.header_weight.push({ id: item.weight_id, weight_name: item.weight_name,
                                        weight_min: item.weight_min, weight_max: item.weight_max,
                                        age_min: item.age_min, age_max: item.age_max,
                                        descripton: item.w_description, history: `${item.w_reguser} / ${item.w_regdate} 등록` });
            });
            if (this.weight_list[0] && this.weight_list[0].season_list[0].season_id) {
            for (let i in this.weight_list[0].season_list) {
                this.header_season.push(
                  { id: this.weight_list[0].season_list[i].season_id, season_name: this.weight_list[0].season_list[i].season_name, 
                    season_from: this.weight_list[0].season_list[i].season_from, season_to: this.makeSeasonTo(i),
                    descripton: this.weight_list[0].season_list[i].s_description,
                    history: `${this.weight_list[0].season_list[i].s_reguser} / ${this.weight_list[0].season_list[i].s_regdate} 등록`  }
                );
              }
            }
            this.$store.commit("resMessage",res.message + "적용후 수정할수 있습니다");
            this.loadDialog = false;
            this.edit_mode = false;
            this.editBtnShow = false;
            this.presetSaveShow = false;
            this.presetConfirmShow = true;
            this.presetCanceShow = true;
          } else {
            alert(res.message);
          }
          this.loading = false;
      }).catch((err) => {
          console.log("saveFanControlPreset 호출 오류", err);
          this.loading = false;
      });

    },
    presetSave(){
      if (!this.presetCompany || !this.presetCompany.code) {
          alert("프리셋 공유 경영체를 선택하세요");
          this.$refs.presetCompany.focus();
          return;
      }
      if (this.presetNm.trim() == "") {
          alert("프리셋 이름을 입력하세요");
          this.$refs.presetNm.focus();
          return;
      }
      this.loading = true;
      Apis.saveFanControlPreset({
          company_cd: this.presetCompany.code,
          preset_name: this.presetNm.trim(),
          range_set: this.weight_list,
      }, (res) => {
          if (res.result) {
            this.$store.commit("resMessage",res.message);
            this.saveDialog = false;
          } else if (res.resultCode == "E300") {
            alert(res.message);
          } else {
            alert(res.message);
          }
          this.loading = false;
      }).catch((err) => {
          console.log("saveFanControlPreset 호출 오류", err);
          this.loading = false;
      });
    },
    presetConfirm(){
      if (!this.building || !this.building.code) {
          alert("축사/건물/구역를 선택하세요");
          this.$refs.building.focus();
          return;
      }
      if (!confirm("주요 확인!\n" + this.building.farm_name + " " +  this.building.name + "의 세팅을 새로 설정합니다, \n 적용후에는 기존 설정을 복구할수 없습니다!!\n 불러온 프리셋을 적용하시겠습니까?")) {
        return
      }
      this.loading = true;
      Apis.confirmFanControlPreset({
          building: {
                      company_cd: this.building.company_cd,
                      farm_cd: this.building.farm_cd,
                      building_cd: this.building.code,
                    },
          list_set: this.weight_list,
      }, (res) => {
          if (res.result) {
            this.saveDialog = false;
            this.refresh();
            this.$store.commit("resMessage",res.message);
          } else {
            alert(res.message);
          }
          this.loading = false;
      }).catch((err) => {
          console.log("confirmFanControlPreset 호출 오류", err);
          this.loading = false;
      });
    }
  },
}
</script>


<style lang="scss" scoped >
@import '@/style/base.scss';
::v-deep .v-dialog{
  box-shadow: none;
}
.line-rota{
  width: 2px;
  margin:4px 6px 3px 1px;
  border-radius: 2px;
  height: 68px;
  
  background-color:#939393;

  transform: rotate(-45deg);
}

.combo_box{
  width:270px;
  display:flex;
  margin-top:5px;
}
.select_farm{
  width:230px !important;
  margin-right:5px !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); 
  border-radius: 10px;
}
.select_preset{
  width:220px !important;
  margin-right:5px !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); 
  border-radius: 10px;
  height: 45px !important;
}

::v-deep .select_preset .v-input__control .v-input__slot{
  min-height: 45px !important;
}
.select_building , .select_room{
  width:200px !important;
  margin-right:5px !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); 
  border-radius: 10px;
}
.refresh_btn{
  padding:5px;
}
.table-container{
  margin-top:10px;
  padding:10px;
  border-radius: 5px;
  border:1px solid #D5D5D5;
  text-align: center;
}

#seasonTable{
  text-align:center;
  display: inline-block;
}
.season_header{
  display:flex;
  // position:relative;
  // margin-top:3px;
}

.weight_header{
  // float:left;
  margin-right: 4px;
  font-size:15px;
  letter-spacing: -1px;
  width:145px;
}

.controlContents{
  // position: absolute;
  // float:left;
  overflow:hidden;
  flex-wrap: wrap;
  margin-left:-34px;
}

.header_date, .weight_des{
  font-size:14px;
  letter-spacing: -1.25px;
  font-weight: normal !important;
}

.table_title{
  width:115px !important;
  height:50px;
  line-height:50px !important;
  display:flex;
  justify-content: center;
  align-items:center;
  padding:10px;
  display:flex;
  font-weight: bold !important;
  color:grey !important;
}
/* 계절1 */
.season_section{
  width:120px;
  height:50px;
  margin:3px 5px 0;
  border-radius: 10px;
  padding:10px !important;
  line-height:17px;
  font-weight: bold !important;
  background-color: #F2F5F8 !important;
  // box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.2);
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.season_btn{
  border-radius:5px;
  margin:4px 4px 5px 4px!important;
  border-color:transparent;
  background-color: #3a4f3f !important;
  color:white !important;
  font-weight: bold !important;
}

.weight_section{
  // display:flex;
  width:100px;
  height:95px;
  margin:5px 10px;
  margin-bottom:10px;
  font-weight:bold !important;
  line-height:17px !important;
  padding: 20px 15px !important;
  border-radius: 10px;
  background-color: #F2F5F8 !important;
  // box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.2);
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}
//클릭했을때
.cursorpointer{
  cursor: pointer;
  box-shadow: 2px 3px 4px 0px #bebebe !important;
}

.set_click:focus{
  border:2px solid #005B96 !important;
  box-shadow: 2px 3px 4px 0px #005B96;
  border-radius: 5px;
}

.setting{
  width: 120px;
  height: 95px;
  margin: 5px;
  border-radius: 10px;
  text-align: center;
}

.fc_info{
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
  // align-items: center; 
  // justify-content: center; 
  padding:5px;
  border: 1px solid #939393 !important;
  border-radius: 5px;
  font-size:13px;
  letter-spacing: -1.5px !important;

  display: flex;
  flex-direction: column;
}
.fc_content{
  display:flex; 
  margin-left:3px;
  // justify-content: space-evenly !important;
  justify-content: center;
  margin-top:1px;
  // margin-top:1.5px;
}
.fc_vent{
  width:35px;
}
.fc_number{
  background-color:#508C9B;
  // padding:0 3px 0 2px;
  color:white;
  border-radius:5px !important;
  // height:18px;
  text-align:center;
  font-size:13px;
  margin-right:5px;
  text-align: center !important;
  width:20px;
  border-radius: 10px;
}
.heater_info{
  padding:0.5px;
  border: solid 1px #939393 !important;
  border-radius: 5px;
  font-size:13px;
  // line-height:20px;
  letter-spacing: -1px !important;
}

.set_info{
  width: 40px;
  height: 100px;
  text-align:center;
  margin:4px 1px 9px;
  padding-bottom:0px;
  border-radius: 5px;
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.2);
  text-align: center;

}

.fan{
  padding-top:25px;
  line-height:70px;
  height:70px;
  margin-bottom:2px;
  background-color: #e8e8e8 !important;
  border-radius: 5px;
  font-size:10px;
  line-height:20px; 
  letter-spacing: -1px !important;
}

.heater{
  padding:5px;
  height:27px;
  background-color: #e8e8e8 !important;
  border-radius: 5px;
  font-size:10px;
  line-height:20px;
  letter-spacing: -1px !important;
}

.normal-btn{
  background-color: #3a4f3f!important;
  color:white !important;
  font-weight: bold !important;
}

.modify_btn{
  background-color: #005B96!important;
  color:white !important;
  font-weight: bold !important;
  margin-top: 15px !important;
  margin-bottom: 10px !important;
  letter-spacing: -0.5px;
  border-color: transparent;
  height:45px !important; 
  width:120px !important; 
  font-size:15px !important;
}

.weight_btn{
  height:30px !important; 
  width:40px !important;
  line-height:30px;
  border-radius: 10px;
  font-size:12px;
  letter-spacing: -1.25px;
  border-color:transparent;
  background-color: $main-color !important;
  color:white !important;
  cursor: pointer;
}
.weight_btn:hover{
  background-color: $point-color !important;
}
.items {
  color: #a3a1a1;
  font-size: 14px;
  text-align: left;
  letter-spacing: -1.2px;
}
.dialog_title{
  font-weight: bold !important;
  margin-top:10px;
}
.preset_title{
  margin-top:10px;
  width:70px; 
  color:#5F5F5F;
  font-weight:500;
}
.input-box{
  width:250px !important;
}
.apply_btn{
  border-radius: 30px !important;
  color:white !important;
  font-weight: bold !important;
  letter-spacing: -0.5px;
  border-color: transparent;
  height: 40px !important;
  width:90px;
  font-size:15px;
}

.brandback{
  background: $main-color !important;
  color:white !important;
}
.brandcolor{
  letter-spacing: -1px;
  font-weight:600;
  border:1px solid $main-color;
  margin-right:5px;
  color:$main-color !important;
}
.icon_fan{
  width:15px;
}
.darkblue{
  background-color:#243642 !important;
}
.sblue{
  background-color:#304E5C !important;
}
.cancel{
  background-color:#575858 !important;
}
.sky{
  background-color:#99AEBA !important;
}




</style>

 